var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-grid-vue',{staticClass:"ag-theme-alpine",attrs:{"columnDefs":_vm.columnDefs,"defaultColDef":_vm.defaultColDef,"rowData":_vm.rowData,"gridOptions":_vm.gridOptions,"rowSelection":"single","domLayout":"autoHeight"},on:{"gridReady":_vm.onGridReady,"cellClicked":_vm.onCellClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }